/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
    db: {
        boilerplate: {
            name: "boilerplate.realm",
        },
    },
    servers: {
        graphql: [
            {
                name: "api-gateway",
                url: "https://pooja-dev-dc.vlinder.io/nft-core/",
            },
        ],
        rest: {
            restServer: {
                baseURL: "https://crm.trag-vlinder.io/crm/",
            },
            loginServer: {
                baseURL:""
            }
        },
    },
    walletConnect: {
        relayURL: "https://walletbridge.vlinder.io/",
    },
    googleAnalytics:{
        key:"UA-184010527-4"
    }
};

export const BLUEPRINT_CONFIG_HEADER = {
    HeaderComp: {
        compProps: {
            image: 'VLINDER_IMAGE',
            title: "vlinder",
            menuList: [
                {
                    renderLink: false,
                    default: true,
                    name: "About Us",
                    link: 'https://vlinder.io'
                },
                {
                    renderLink: true,
                    default: true,
                    name: "Sports",
                    link: '/sports'
                },
                {
                    renderLink: true,
                    default: true,
                    name: "Collectible",
                    link: '/collectibles'
                },
                {
                    renderLink: true,
                    default: true,
                    name: "Entertainment",
                    link: '/entertainment'
                },
                {
                    renderLink: true,
                    default: false,
                    name: "Contact Us",
                    link: '/contact-us'
                }
            ],
            showAvatar: {
                renderAvatar: true,
                loggedIn: false,
                nameInital: "AR",
                color: 'red',
                submenu: 'true',
                submenuData: [{
                        renderLink: true,
                        name: "My Wallet",
                        link: '/my-wallet'
                    },
                    {
                        renderLink: true,
                        name: "My Profile",
                        link: '/my-profile'
                    },
                    {
                        renderLink: true,
                        name: "My Transactions",
                        link: '/my-transactions'
                    }
                ]
            }
        }
    }
}

export const BLUEPRINT_CONFIG_FOOTER = {
    FooterComp: {
        compProps: {
            title: 'vlinder',
            subtitle: 'IoT Feels, AI thinks, Blockchain remembers',
            aboutUs: [
                {
                    renderLink: false,
                    name: "Want to know about Vlinder?",
                    link: 'https://vlinder.io'
                },
                {
                    renderLink: true,
                    name: "What is a NFT?",
                    link: '/'
                },
                {
                    renderLink: true,
                    name: "NFT Revolution",
                    link: '/'
                },
                {
                    renderLink: true,
                    name: "Terms of service",
                    link: '/terms'
                },
                {
                    renderLink: true,
                    name: "Privacy Policy",
                    link: '/privacy'
                }
            ],
            labelData: "Get the latest NFT updates",
        }
    }
}

export const BLUEPRINT_CONFIG_CONTACT_US = {
    ContactComp: {
        compProps: {
            title: 'Contact Us',
            name: 'Name',
            email: 'Email',
            subject: 'Subject',
            message: 'Message',
            submit: 'Submit'
        }
    }
}